import { render, staticRenderFns } from "./AegPolicyList.vue?vue&type=template&id=02c5d7e6"
import script from "./AegPolicyList.vue?vue&type=script&lang=js"
export * from "./AegPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports